<template>
  <span class="GREEN-BUBBLE ellipsize">
    {{ bubbleTextLabel }}
  </span>
</template>

<script>
import capitalizeAll from '@/filters/capitalizeAll';

export default {
  name: 'green-bubble',
  props: {
    bubbleText: {
      type: String,
      required: true,
    },
  },
  computed: {
    bubbleTextLabel () {
      return capitalizeAll(this.bubbleText);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .GREEN-BUBBLE {
    @include text-small;
    max-width: 100%;
    margin-top: 0.75*$unit;
    padding: $unit/4 0.75*$unit;
    align-self: flex-start;
    color: #389E0D;
    font-weight: 400;
    background-color: #F6FFED;
    border: 1px solid #389E0D;
    border-radius: $unit*4;
  }
</style>
